import React from 'react'

import type { IconProps } from './types'

const Expert: React.FC<IconProps> = ({
  size = 24,
  color = '#2D87F3',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M0 8a8 8 0 0 1 8-8h32v40H0z" fill="#fff" />
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
        fill="#fff"
      />
      <path
        d="M23.333 16.667V10h-6.666v6.667H10v6.667h6.667V30h6.666v-6.666H30v-6.667z"
        fill={color}
      />
    </svg>
  )
}

export default Expert
